/**
 * model of parameters for Materialize modals
 */
export interface MaterializeModalParams {
  dismissible: boolean;
  opacity: number;
  out_duration: number;
  complete?: Function;
  ready?: Function;
}
